import { render } from "./DocumentsTab.vue?vue&type=template&id=64f2f730"
import script from "./DocumentsTab.vue?vue&type=script&lang=js"
export * from "./DocumentsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__